<template>
  <div class="popUpWrap dark">
    <section class="slidePopup dark guide" :class="{on: show}">
      <div class="topArea">
        <p>{{ t('advance-guide') }}</p>
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="titleArea">
          <h2>{{ dialogStore.options.props?.track?.trackTitle }}</h2>

          <ul class="categoryArea">
            <li><svg xmlns="http://www.w3.org/2000/svg" width="14" height="6" viewBox="0 0 14 6" fill="none">
              <path d="M10.0647 0.701448L12.3662 2.99995L10.0647 5.29845" stroke="#9098AA" stroke-linecap="round"></path>
              <path d="M7.76622 0.699951L6.23389 5.29696" stroke="#9098AA" stroke-linecap="round"></path>
              <path d="M3.93533 0.701448L1.63384 2.99995L3.93533 5.29845" stroke="#9098AA" stroke-linecap="round"></path>
            </svg></li>
            <li v-for="(category, index) in dialogStore.options.props?.track?.categories" :key="index">
              {{ category }}
            </li>

          </ul>
        </div>
        <div
            v-for="(trackLevel, index) in dialogStore.options.props?.track?.trackLevelAssessmentSetVOList"

            :key="index"
            class="trackLevelMenu"
            :class="{on: openFlagList[index]}"
        >
          <div class="titleArea" @click.stop="openFlagList[index] = !openFlagList[index]">
            <div class="progress">
              <div class="circleArea" :class="levelClass(trackLevel.level)">
                <div class="step">{{ TrackLevelModel.levelInitials(trackLevel.level, isGeneralLevel) }}</div>
              </div>
            </div>
            <div class="titInfo">
              <h3>{{ trackLevel.title }}</h3>
              <span class="caret"></span>
            </div>
          </div>
          <div class="info">
            <pre v-html="trackLevel.description"></pre>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {computed} from '#imports';
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useI18n} from 'vue-i18n';
import {TrackLevelModel} from "~~/package/mapper/track/model/TrackLevelModel";
import {TrackModel} from "~~/package/mapper/track/model/TrackModel";

const {t} = useI18n()

const dialogStore = useDialogStore();

const openFlagList = ref<Boolean[]>([]);
const show = ref(false);

const isGeneralLevel = computed(() => {
  return TrackModel.isGeneralLevel(dialogStore.options.props?.track?.trackLevelAssessmentSetVOList || [])
})


onMounted(() => {
  openFlagList.value = new Array(dialogStore.options.props?.track?.trackLevelAssessmentSetVOList?.length || 0).fill(false);
  openFlagList.value[0] = true;


  nextTick(() => {
    setTimeout(() => {
      show.value = true
    }, 10)
  })
});

const levelClass = (level: number) => {
  const levelNumber = isGeneralLevel.value ? '_G' : Math.min(level, 3);
  return {
    [`levelBadge${levelNumber}`]: true
  }
};

const onClickClose = () => {
  show.value = false;
  dialogStore.close();
};
</script>

